import React from 'react';
import { Typography, Box } from '@mui/material';

export default function ContractReferenceCell({ reference, userReference, variant = 'body2' }) {
  const hasUser = userReference && String(userReference).trim().length > 0;
  return (
    <Box>
      <Typography variant={variant} sx={{ fontWeight: 'bold' }} noWrap>
        {hasUser ? userReference : reference}
      </Typography>
      {hasUser && reference && (
        <Typography variant="caption" color="textSecondary" noWrap component="div">
          {reference}
        </Typography>
      )}
    </Box>
  );
}
